import I18n from 'I18n';
import Env from 'enviro';
import { PORTAL_SPECIFIC_EVENT } from 'automation-ui-references/object-types/InboundDbMetaTypeIds';
import { WEBHOOK_EVENTS_GROUP } from 'automation-ui-enrollment/constants/TriggerGroups';

/**
 * The BE separates the label that a customer would see and a unique identifier for the property. If the label for a property
 * were to be "Shipping Label" then the property name would be an alphanumeric lower case string of the label, "shippinglabel"
 * @param label string to convert
 * @returns Alphanumeric lowercase label
 */

export const toLowerCaseAlphanumeric = label => label.replace(/\W/g, '').toLowerCase();
export const formatEventProperties = mappings => {
  return mappings.map(webhookMapping => {
    const propertyName = toLowerCaseAlphanumeric(webhookMapping.name);
    const propertySource = {
      valueSourceType: 'JSON_PATH',
      jsonPathForPropertyValue: `$${webhookMapping.property}`
    };
    if (webhookMapping.type === 'enumeration') {
      const enumProperty = {
        type: 'enumeration',
        label: webhookMapping.name,
        propertyName,
        options: webhookMapping.options,
        propertySource
      };
      return enumProperty;
    } else if (webhookMapping.type === 'bool') {
      const boolProperty = {
        type: 'bool',
        label: webhookMapping.name,
        propertyName,
        propertySource,
        options: [{
          value: 'true',
          label: 'True',
          displayOrder: 0
        }, {
          value: 'false',
          label: 'False',
          displayOrder: 1
        }]
      };
      return boolProperty;
    } else {
      const genericProperty = {
        type: webhookMapping.type,
        label: webhookMapping.name,
        propertyName,
        propertySource
      };
      return genericProperty;
    }
  });
};
export const getFilterGroups = filters => [{
  filters: filters
  // Remove empty filters
  .filter(filter => filter.hubspotProperty && filter.webhookProperty).map(filter => ({
    operator: 'EQ',
    propertyValueDefinition: {
      propertyName: filter.hubspotProperty,
      propertySource: {
        valueSourceType: 'JSON_PATH',
        jsonPathForPropertyValue: `$${filter.webhookProperty}`
      }
    }
  }))
}];
export const getPropertyValueDefinitions = propertyValueDefinitions => propertyValueDefinitions
// Remove empty properties
.filter(prop => prop.hubspotProperty && prop.webhookProperty).map(property => ({
  propertyName: property.hubspotProperty,
  propertySource: {
    valueSourceType: 'JSON_PATH',
    jsonPathForPropertyValue: `$${property.webhookProperty}`
  }
}));
export const getPropertyDropdownOptions = (propertyMappings, type) => {
  return propertyMappings.map(mapping => ({
    text: mapping.name,
    value: mapping.property,
    disabled: type ? mapping.type !== type : undefined,
    help: type && mapping.type !== type ? I18n.text('automation-ui-enrollment.webhookWizard.associatingObject.propertyMatching.source.help') : undefined
  }));
};
export const getWebhookUrlForDefinition = webhook => `https://api-${Env.getHublet()}.hubapi.com/automation/v4/webhook-triggers/${webhook.portalId}/${webhook.callbackId}`;
export const convertWebhookToEventTriggerOption = webhook => ({
  text: webhook.label,
  entityName: webhook.label,
  groupHeading: webhook.label,
  value: `${PORTAL_SPECIFIC_EVENT}-${webhook.eventTypeId.innerId}`,
  supportedObjectTypeIds: [webhook.objectTypeId],
  fullyQualifiedName: webhook.eventFullyQualifiedName,
  categoryId: 'advanced',
  groupId: WEBHOOK_EVENTS_GROUP,
  groupLabel: I18n.text('automation-ui-enrollment.redesign.events.groups.third-party')
});